import regexList from "./utils/regexList";
import regexTest from "./utils/regexTest";

export default function isNumber(str, responseText) {
    const regVal = regexList.nepEngNo.pattern;
    return regexTest(str, regVal, responseText) || regexList.nepEngNo.response;
}